import { DownloadOutlined } from '@ant-design/icons';
import { Alert, Button } from 'antd';
import PropTypes from 'prop-types';
import React from "react";
import { useFetcher, useLoaderData } from 'react-router-dom';
import { Box } from '../../../components/design';
import { DatePicker, FieldWrapper, InputWrapper } from "../../../components/inputs";
import { VendorDeliveryStatus, VendorRole } from '../../../library/constants/supplier.js';
import { getFilePath } from '../../../library/constants/urls.js';
import { formatDate } from '../../../library/utils/intl.js';
import styles from "./in-production.module.scss";


export const ShipmentExpectedDispatchDate = ({ projectId, shipments, itemId, deliveryType = null, buttonText = "Save dates & Update Leoprinting" }) => {
    const fetcher = useFetcher()
    const { errors = {} } = fetcher.data || {}
    const getAddress = (shipment) => {
        if (deliveryType === 3) {
            return <Button href={getFilePath(shipment.bulk_address_file.url, projectId, itemId)} icon={<DownloadOutlined />}>Download</Button>
        }
        else {
            return <>{shipment.street_number},{shipment.street},{shipment.city}</>
        }
    }

    return (
        <fetcher.Form method="post">
            <Box header={
                <div className={deliveryType === 3 ? styles.deliveryRowHeadWithComment : styles.deliveryRowHead}>
                    <div>Quantity</div>
                    <div>Delivery Address</div>
                    <div>Expected Dispatch Date</div>
                    {deliveryType === 3 && (
                        <div>
                            Comment
                        </div>
                    )}
                    <div></div>
                </div>
            }>
                <input type="hidden" name="action" value="sendDispatchInfo" />
                {shipments && shipments.map((shipment, index) => (
                    <React.Fragment key={shipment.id}>
                        <div className={deliveryType === 3 ? styles.deliveryRowWithComment : styles.deliveryRow}>
                            <input type="hidden" name={`[${index}]shipping_id`} value={shipment.id} />
                            <div className="quantity">{shipment.quantity}</div>
                            <div className="address">{getAddress(shipment)}</div>
                            <div className="field-expected_dispatch_date">
                                <FieldWrapper name={`[${index}]dispatch_date`} errors={errors} >
                                    <DatePicker name={`[${index}]dispatch_date`} value={shipment.dispatch_date} useHidden />
                                </FieldWrapper>
                            </div>
                            {deliveryType === 3 && (
                                <div>
                                    <InputWrapper name={`[${index}]dispatch_date_comment`} defaultValue={shipment.dispatch_date_comment} textarea errors={errors} />
                                </div>
                            )}
                        </div>
                    </React.Fragment>
                ))}
                <br />
                <div className="actions align--right">
                    <Button type='primary' htmlType='submit'>{buttonText}</Button>
                </div>
            </Box>
        </fetcher.Form >
    )
}
ShipmentExpectedDispatchDate.propTypes = {
    projectId: PropTypes.number.isRequired,
    itemId: PropTypes.number.isRequired,
    shipments: PropTypes.arrayOf(PropTypes.object).isRequired,
    deliveryType: PropTypes.oneOf([1, 2, 3]),
    buttonText: PropTypes.string
}

const InProduction = () => {
    const { productionDetails, supplier_flow } = useLoaderData()
    return (
        <div className={styles.container}>

            {supplier_flow == VendorRole.BOTH ?
                <div>
                    <h3>Task For You</h3>
                    <ShipmentExpectedDispatchDate projectId={productionDetails.project_id} itemId={productionDetails.id} deliveryType={productionDetails.delivery_type} shipments={productionDetails.item_delivery_address} />
                </div> :
                supplier_flow == VendorRole.ONLY_FINISHER ?
                    <div>
                        {
                            productionDetails.vendor_delivery_status == VendorDeliveryStatus.DELIVERED ?
                                <div>
                                    {productionDetails.item_delivery_address?.ship_quantity &&
                                        <Alert
                                            message="Vendor have delivered the products."
                                            description={productionDetails.item_delivery_address?.ship_quantity && `Quantity recieved from Vendor : ${productionDetails.item_delivery_address?.ship_quantity}`} type="success" showIcon />
                                    }
                                    <h3>Task For You</h3>
                                    <ShipmentExpectedDispatchDate projectId={productionDetails.project_id} itemId={productionDetails.id} deliveryType={productionDetails.delivery_type} shipments={productionDetails.item_delivery_address} />
                                </div> :
                                <div>
                                    {productionDetails.item_delivery_address && <Alert
                                        message="Vendor haven't shipped the product to you yet."
                                        description={productionDetails.item_delivery_address?.expected_delivery_date && `Expected Delivery Date : ${formatDate(productionDetails.item_delivery_address?.expected_delivery_date)}`} type="info" showIcon />}
                                </div>
                        }
                    </div> :
                    <div></div>
            }


        </div>
    )
}

export default InProduction;



// import PropTypes from 'prop-types';
// import React from "react";
// import { useFetcher, useLoaderData } from 'react-router-dom';
// import { Box } from '../../../components/design/box';
// import { DatePicker, FieldWrapper } from "../../../components/inputs";
// import styles from "./in-production.module.scss";


// const ShipmentExpectedDispatchDate = ({ projectId, itemId, shipments, deliveryType = null, buttonText = "Save dates & Update Customer" }) => {
//     const fetcher = useFetcher()
//     const { errors = {} } = fetcher.data || {}
//     const getAddress = (shipment) => {
//         if (deliveryType === 3) {
//             return <Button href={getFilePath(shipment.bulk_address_file.url, projectId)} icon={<DownloadOutlined />}>Download</Button>
//         }
//         else {
//             <>{shipment.street_number},{shipment.street},{shipment.city}</>
//         }
//     }

//     return (
//         <fetcher.Form method="post" action={generateRouteUrl('InProduction', {
//             itemId
//         })}>
//             <Box header={
//                 <div className={deliveryType === 3 ? styles.deliveryRowHeadWithComment : styles.deliveryRowHead}>
//                     <div>Quantity</div>
//                     <div>Delivery Address</div>
//                     <div>Expected Dispatch Date</div>
//                     {deliveryType === 3 && (
//                         <div>
//                             Comment
//                         </div>
//                     )}
//                     <div></div>
//                 </div>
//             }>
//                 <input type="hidden" name="action" value="sendDispatchInfo" />
//                 {shipments && shipments.map((shipment, index) => (
//                     <React.Fragment key={shipment.id}>
//                         <div className={deliveryType === 3 ? styles.deliveryRowWithComment : styles.deliveryRow}>
//                             <input type="hidden" name={`[${index}]shipping_id`} value={shipment.id} />
//                             <div className="quantity">{shipment.quantity}</div>
//                             <div className="address">{getAddress(shipment)}</div>
//                             <div className="field-expected_dispatch_date">
//                                 <FieldWrapper name={`[${index}]dispatch_date`} errors={errors} >
//                                     <DatePicker name={`[${index}]dispatch_date`} value={shipment.dispatch_date} useHidden />
//                                 </FieldWrapper>
//                             </div>
//                             {deliveryType === 3 && (
//                                 <div>
//                                     <InputWrapper name={`[${index}]dispatch_date_comment`} defaultValue={shipment.dispatch_date_comment} textarea errors={errors} />
//                                 </div>
//                             )}
//                         </div>
//                     </React.Fragment>
//                 ))}
//                 <div className="actions align--right">
//                     <Button type='primary' htmlType='submit'>{buttonText}</Button>
//                 </div>
//             </Box>
//         </fetcher.Form >
//     )
// }

// ShipmentExpectedDispatchDate.propTypes = {
//     projectId: PropTypes.number.isRequired,
//     itemId: PropTypes.number.isRequired,
//     shipments: PropTypes.arrayOf(PropTypes.object).isRequired,
//     deliveryType: PropTypes.oneOf([1, 2, 3]),
//     buttonText: PropTypes.string
// }

// const DeliveryTrackingRow = ({ item }) => {

//     const fetcher = useFetcher()
//     const { errors = {} } = fetcher.data || {}
//     const handleChange = (dispatch_date, shipment_id) => {
//         const payload = { "shipment_id": shipment_id, "dispatch_date": dispatch_date }
//         fetcher.submit({
//             ...payload,
//             action: 'sendDispatchInfo'
//         }, {
//             method: 'post'
//         })
//     }
//     return (
//         <ShipmentExpectedDispatchDate projectId={orderDetails.project_id} itemId={orderDetails.id} deliveryType={orderDetails.delivery_type} shipments={orderDetails.item_delivery_address} />

//         // <fetcher.Form method="post">
//         //     <input type="hidden" name="shipment_id" value={item.id} />
//         // {/* <div className={styles.deliveryRow}>
//         //         <div className="quantity">{item.quantity}</div>
//         //         <div className="address">{item.street_number},{item.street},{item.city}</div>

//         //         <div className="field-expecteddispatchdate">
//         //             <FieldWrapper name="expected_date" errors={errors} >
//         //                 <DatePicker name="dispatch_date" value={item?.dispatch_date} useHidden onChange={(e) => {
//         //                     handleChange(e, item.id)

//         //                 }} />
//         //             </FieldWrapper>
//         //         </div>

//         //     </div> */}

//         // </fetcher.Form>
//     )

// }
// DeliveryTrackingRow.propTypes = {
//     item: PropTypes.object.isRequired
// }

// const InProduction = () => {

//     const { deliveryDetails } = useLoaderData()
//     return (
//         <ShipmentExpectedDispatchDate projectId={orderDetails.project_id} itemId={orderDetails.id} deliveryType={deliveryDetails.delivery_type} shipments={deliveryDetails.item_delivery_address} />

//         // <div className={styles.container}>
//         //     <h3>Task For You</h3>
//         //     <Box header={
//         //         <div className={styles.deliveryRowHead}>
//         //             <div>Quantity</div>
//         //             <div>Delivery Address</div>
//         //             <div>Expected Dispatch Date</div>
//         //             <div></div>
//         //         </div>
//         //     }>
//         //         {deliveryDetails && deliveryDetails.map((shipment) => <DeliveryTrackingRow key={shipment.id} item={shipment} />)}
//         //     </Box>
//         // </div>
//     )

// }


// export default InProduction;





